// Iconos de trazo (24x24) de la Consola y de la isla del telefono. Sin dependencias.
import type { CSSProperties } from 'react';

const PHONE = 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2';

const PATHS = {
  phone: PHONE,
  phoneIn: `${PHONE}M16 3v5h5M22 2l-6 6`,
  phoneOut: `${PHONE}M17 2h5v5M16 8l6-6`,
  phoneMiss: `${PHONE}M16 3l5 5M21 3l-5 5`,
  home: 'M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
  users: 'M16 20v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 20v-1a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  user: 'M20 21v-1a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v1M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  kanban: 'M4 4h4v16H4zM10 4h4v10h-4zM16 4h4v7h-4z',
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.3-4.3',
  mic: 'M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v3',
  micOff: 'M2 2l20 20M9 9v3a3 3 0 0 0 5.1 2.1M15 9.3V5a3 3 0 0 0-5.9-.6M19 10v2a7 7 0 0 1-.6 2.8M5 10v2a7 7 0 0 0 12 5M12 19v3',
  pause: 'M8 5v14M16 5v14',
  keypad: 'M5 4h.01M12 4h.01M19 4h.01M5 10h.01M12 10h.01M19 10h.01M5 16h.01M12 16h.01M19 16h.01M12 21h.01',
  transfer: 'M17 3l4 4-4 4M21 7H9M7 21l-4-4 4-4M3 17h12',
  conf: 'M15 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM20 8v6M23 11h-6',
  park: 'M4 4h16v16H4zM10 16V8h3a2.5 2.5 0 0 1 0 5h-3',
  record: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z',
  card: 'M3 5h18v14H3zM9 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM5.5 16a3.5 3.5 0 0 1 7 0M15 9h4M15 13h4',
  tag: 'M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8zM7.5 7.5h.01',
  note: 'M4 4h16v12l-4 4H4zM16 20v-4h4M8 9h8M8 13h5',
  backspace: 'M21 5H9l-6 7 6 7h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM16 9l-5 6M11 9l5 6',
  voicemail: 'M6.5 15.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2zM17.5 15.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2zM6.5 15.6h11',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  play: 'M7 4l13 8-13 8z',
  mail: 'M3 5h18v14H3zM3 6l9 7 9-7',
  check: 'M20 6 9 17l-5-5',
  task: 'M4 4h16v16H4zM8 12l3 3 5-6',
  spark: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z',
  x: 'M18 6 6 18M6 6l12 12',
  external: 'M14 3h7v7M21 3l-9 9M19 14v6H4V5h6',
  download: 'M12 3v12M7 10l5 5 5-5M4 19h16',
  inbox: 'M3 13h5l2 3h4l2-3h5M5 5h14l2 8v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6z',
  trend: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  star: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z',
  archive: 'M3 4h18v4H3zM5 8v12h14V8M10 12h4',
  send: 'M22 2 11 13M22 2l-7 20-4-9-9-4z',
  reply: 'M9 14 4 9l5-5M4 9h10a6 6 0 0 1 6 6v3',
  plus: 'M12 5v14M5 12h14',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.94 1.94 0 0 0 3.4 0',
  video: 'M3 7h13v10H3zM16 11l5-3v8l-5-3',
  swap: 'M7 4v16M7 4 3 8M7 4l4 4M17 20V4M17 20l-4-4M17 20l4-4',
  building: 'M4 21V4h10v17M14 9h6v12M8 8h2M8 12h2M8 16h2M3 21h18',
  sliders: 'M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6',
  wave: 'M2 12h3l3-8 4 16 4-12 3 4h3',
  headset: 'M4 15v-3a8 8 0 0 1 16 0v3M4 15a2 2 0 0 0 2 2h1v-5H6a2 2 0 0 0-2 2zM20 15a2 2 0 0 1-2 2h-1v-5h1a2 2 0 0 1 2 2zM17 17v1a3 3 0 0 1-3 3h-2',
  chevUp: 'm6 15 6-6 6 6',
  chevDown: 'm6 9 6 6 6-6',
  chevRight: 'm9 6 6 6-6 6',
  chevLeft: 'm15 6-6 6 6 6',
  window: 'M3 4h18v16H3zM3 8.5h18',
  status: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
  trash: 'M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3',
  key: 'M7.5 20.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zM10.7 12.3 21 2M17 6l3 3M14.5 8.5l2 2',
  paperclip: 'M21 11.5l-8.5 8.5a5 5 0 0 1-7-7L14 4.5a3.3 3.3 0 0 1 4.7 4.7L10.2 17.7a1.7 1.7 0 0 1-2.4-2.4L15.5 7.6',
  logout: 'M15 4h4v16h-4M10 17l5-5-5-5M15 12H3',
  refresh: 'M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6',
  lock: 'M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v6M12 7.5h.01',
  alert: 'M12 3 2 20h20zM12 10v4M12 17.5h.01',
  money: 'M3 6h18v12H3zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 9h.01M18 15h.01',
  calendar: 'M4 5h16v16H4zM4 10h16M9 3v4M15 3v4',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7L12 6M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7L12 18',
  dots: 'M5 12h.01M12 12h.01M19 12h.01',
  filter: 'M3 5h18l-7 8v6l-4 2v-8z',
  // Base de conocimiento (Manual) y Accesos
  book: 'M4 4.5A1.5 1.5 0 0 1 5.5 3H20v16H5.5A1.5 1.5 0 0 0 4 20.5zM4 20.5A1.5 1.5 0 0 0 5.5 22H20M8 7h8',
  doc: 'M6 3h9l4 4v14H6zM15 3v4h4M9 12h7M9 16h5',
  router: 'M3 7h18v10H3zM7 12h.01M11 12h.01M15 12h2',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  code: 'M8 7l-5 5 5 5M16 7l5 5-5 5',
  image: 'M3 4h18v16H3zM8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM21 15l-5-5L5 20',
  heading: 'M6 4v16M18 4v16M6 12h12',
  listNum: 'M10 6h11M10 12h11M10 18h11M4 6h1v4M4 10h2M6 18H4c0-1 2-2 2-3s-1-1.5-2-1',
  quote: 'M4 4h16v12H8l-4 4z',
  bold: 'M7 4h6a4 4 0 0 1 0 8H7zM7 12h7a4 4 0 0 1 0 8H7z',
  thumbUp: 'M7 10v11H3V10zM7 10l4-8a3 3 0 0 1 3 3v4h6a2 2 0 0 1 2 2.3l-1.4 8A2 2 0 0 1 18.6 21H7',
} as const;

export type IconName = keyof typeof PATHS;

const FILLED: Partial<Record<IconName, true>> = { play: true, record: true };

export function Icon({
  name,
  size,
  className = 'i',
  style,
  title,
}: {
  name: IconName;
  size?: number;
  className?: string;
  style?: CSSProperties;
  title?: string;
}) {
  const filled = FILLED[name];
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      style={{ ...(size ? { width: size, height: size } : null), ...(filled ? { fill: 'currentColor', stroke: 'none' } : null), ...style }}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      <path d={PATHS[name]} />
    </svg>
  );
}

// Telefono relleno (boton verde/rojo de llamada).
export function PhoneFilled({ size = 24, hang = false }: { size?: number; hang?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden style={hang ? { transform: 'rotate(135deg)' } : undefined}>
      <path d={PHONE} fill="currentColor" stroke="none" />
    </svg>
  );
}
